import React from "react";
import { useFormikContext } from "formik";
import { HelpBlock } from "components/bootstrap";
import OperatorField from "data-lake/preview/OperatorField";
import FieldFiltersConfiguration from "data-lake/FieldFiltersConfiguration/FieldFiltersConfiguration";
import StyledLabel from "data-lake/components/DataLakeActionModals/StyledLabel";
const FieldsFiltersField = () => {
  const {
    values: { fieldFilters }
  } = useFormikContext();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledLabel, null, "Filter by fields"), /* @__PURE__ */ React.createElement(HelpBlock, null, "Here you can add field filters."), !!fieldFilters.length && /* @__PURE__ */ React.createElement(OperatorField, null), /* @__PURE__ */ React.createElement(FieldFiltersConfiguration, { maxFilters: 3 }));
};
export default FieldsFiltersField;
